import React, { useState } from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
import { useGate } from 'effector-react';
import { TemplateId } from '@types';
import flexBoxHack from '@utils/flexBoxHack';
import { $templateId } from '@stores/dataStores';
import LibModalListBody from '../layouts/LibModalListBody';
import LibModalList from '../layouts/LibModalList';
import { $libSelectedApi } from '../stores/libSelected';
import { TagGroup } from '../LibIconModal/ListSysIcons';
import { cbIconList } from './cbIconList';
import { LibItemsGate } from '../stores/libState';
import { IconItem } from './IconItem';

export function LibCBIcons() {
  const [typeIndex, setTypeIndex] = useState(() => {
    const templateId = $templateId.getState();
    if (templateId === TemplateId.legacy) return 0;
    if (templateId === TemplateId.realEstateB) return 3;
    if (templateId === TemplateId.metaverseA) return 4;
    if (templateId === TemplateId.simple) return 2;
    return 1;
  });

  const group = cbIconList[typeIndex];

  const items = group.list ?? [];

  useGate(LibItemsGate, items);

  return (
    <LibModalList>
      <div className="bg-white-light px-15 pt-15">
        <TagGroup
          title="类别"
          items={cbIconList}
          activeIndex={typeIndex}
          onClick={(index) => {
            $libSelectedApi.clear();
            setTypeIndex(index);
          }}
        />
      </div>
      <LibModalListBody>
        <Scrollbars>
          <div className="flex flex-wrap items-center justify-between py-15 px-10">
            {items.map((x, i) => (
              <IconItem data={x} key={x.url} size={group.size} index={i} />
            ))}
            {flexBoxHack(90, 7)}
          </div>
        </Scrollbars>
      </LibModalListBody>
    </LibModalList>
  );
}
